import { render, staticRenderFns } from "./FormBuilderField.vue?vue&type=template&id=4dd4bdee&"
import script from "./FormBuilderField.vue?vue&type=script&lang=js&"
export * from "./FormBuilderField.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderField.vue?vue&type=style&index=0&id=4dd4bdee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports